import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="form-submit-confirm"
export default class extends Controller {
  static targets = ['submit'];
  static values = {
    message: String,
  };

  connect() {
    this.element.addEventListener('submit', (e) => {
      if (this.messageValue && !confirm(this.messageValue)) {
        e.preventDefault();
        return;
      }

      if (this.submitTarget) {
        this.submitTarget.disabled = true;
      }
    });
  }
}
